// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__26LHU","obliqueLineWrap":"membershipbadge_obliqueLineWrap__gYbKW","obliqueLine":"membershipbadge_obliqueLine__300Qg"};